import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const AmericanNewLogin = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogin = () => {
    const currentParams = location.search;
    navigate(`/regional-landing-americannew-mobile${currentParams}`);
  };

  const handleSignUp = () => {
    const currentParams = location.search;
    navigate(`/regional_new-onboarding_steppper-americannew-mobile${currentParams}`);
  };

  return (
    <div className="rn-login">
      <div className="rn-login-container">
        {/* Status Bar */}
        <div className="rn-status-bar">
          <span className="rn-status-time">15:19</span>
          <div className="rn-status-icons">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="6" width="4" height="14" rx="1" fill="#374151"/>
              <rect x="7" y="4" width="4" height="16" rx="1" fill="#374151"/>
              <rect x="13" y="2" width="4" height="18" rx="1" fill="#374151"/>
              <rect x="19" y="0" width="4" height="20" rx="1" fill="#D1D5DB"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 6C1 6 5 2 12 2C19 2 23 6 23 6" stroke="#374151" strokeWidth="2" strokeLinecap="round"/>
              <path d="M5 10C5 10 7.5 7 12 7C16.5 7 19 10 19 10" stroke="#374151" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="12" cy="14" r="2" fill="#374151"/>
            </svg>
            <svg width="20" height="12" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="24" height="13" rx="3.5" stroke="#374151"/>
              <rect x="2" y="2" width="18" height="10" rx="2" fill="#374151"/>
              <rect x="26" y="4" width="2" height="6" rx="1" fill="#374151"/>
            </svg>
          </div>
        </div>

        {/* Expand Icon */}
        <div className="rn-expand-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" stroke={colors.cuaternario || '#1a1a2e'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Logo */}
        <div className="rn-logo-section">
          {colors.url_logo ? (
            <img src={colors.url_logo} alt="Logo" className="rn-logo-image" />
          ) : (
            <div className="rn-logo-placeholder">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30 5L50 20L30 55L10 20L30 5Z" fill={colors.primario} fillOpacity="0.8"/>
                <path d="M30 5L40 20H20L30 5Z" fill={colors.primario}/>
                <path d="M20 20L30 55L10 20H20Z" fill={colors.primario} fillOpacity="0.6"/>
                <path d="M40 20L30 55L50 20H40Z" fill={colors.primario} fillOpacity="0.4"/>
              </svg>
            </div>
          )}
        </div>

        {/* Title */}
        <h1 className="rn-login-title" style={{ color: colors.primario }}>Welcome!</h1>
        <p className="rn-login-subtitle">Enter your info</p>

        {/* Form Fields */}
        <div className="rn-login-form">
          <div className="rn-form-group">
            <label className="rn-form-label">Email, Phone or ID Number</label>
            <div className="rn-input-wrapper">
              <input type="text" className="rn-input" defaultValue="lavila@veritran.com" readOnly />
            </div>
          </div>

          <div className="rn-form-group">
            <label className="rn-form-label">PIN</label>
            <div className="rn-input-wrapper">
              <input type="password" className="rn-input" defaultValue="1234" readOnly />
            </div>
          </div>

          <div className="rn-forgot-pin">
            <span style={{ color: colors.primario }}>I forgot my PIN</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="rn-login-actions">
          <button
            className="rn-btn-login"
            style={{ backgroundColor: colors.primario }}
            onClick={handleLogin}
          >
            Log in
          </button>

          <div className="rn-fingerprint">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="11" width="18" height="11" rx="2" stroke={colors.primario} strokeWidth="2"/>
              <path d="M7 11V7a5 5 0 0110 0v4" stroke={colors.primario} strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span style={{ color: colors.primario }}>Use Fingerprint</span>
          </div>

          <div className="rn-signup-link">
            <span className="rn-signup-text">Don't have an account? </span>
            <span
              className="rn-signup-action"
              style={{ color: colors.primario }}
              onClick={handleSignUp}
            >
              Sign up now
            </span>
          </div>
        </div>

        {/* Home Indicator */}
        <div className="rn-home-indicator">
          <div className="rn-home-bar"></div>
        </div>
      </div>
    </div>
  );
};
